export const TRANSFER_IN = "Transfer In";
export const TRANSFER_OUT = "Transfer Out";
export const TRANSFER_ASSET_SWAP = "Asset Swap";

export const PENDING_TRANSFERS_TABLE = "PendingTransferRequests";
export const HISTORY_TRANSFERS_TABLE = "HistoryTransferRequests";

export const STATUS_REQUEST = {
	PENDING: "Pending Approval",
	PENDING_ARRIVAL_APPROVAL: "Pending Arrival and Approval",
	PENDING_INVENTORY: "Pending Inventory Transfer",
	PENDING_ARRIVAL: "Pending Arrival",
	AVAILABLE_FOR_TRADE: "Available for Trade",
	APPROVED: "Approved",
	COMPLETED: "Completed",
	CANCELLED: "Cancelled",
	REJECTED: "Rejected",
};

export enum EActionType {
	"APPROVE" = "approve",
	"REJECT" = "reject",
	"CANCEL" = "cancel",
	"CONFIRM" = "confirm",
	"CANCEL_CONFIRMATION" = "cancel_confirmation",
}

export const TYPE_TRANSFER_REQUEST = [TRANSFER_IN, TRANSFER_OUT, TRANSFER_ASSET_SWAP, ""] as const;

export const STATUS_OPTIONS = [
	{ label: "New", value: "New" },
	{ label: "Used", value: "Used" },
];

export const GIVING = "Giving";
export const RECEIVING = "Receiving";

export const APPROVE = "Approve";
export const REJECT = "Reject";
export const CONFIRM = "Confirm";
export const DECLINE = "Decline";
export const CANCEL = "Cancel";
export const APPROVE_REJECT = `${APPROVE}/${REJECT}`;
export const CONFIRM_DECLINE = `${CONFIRM}/${DECLINE}`;

const ZERO = 0;
const ONE = 1;
const TWO = 2;
const THREE = 3;

export const FIXED_SIZE_HEIGHT_TABS = [ZERO, ONE, TWO, THREE];

export enum InventoryTab {
	NEW_VEHICLES = "NEW_VEHICLES",
	PREOWNED_VEHICLES = "PREOWNED_VEHICLES",
	KMS = "KMS",
	DEALER_TRADES = "DEALER_TRADES",
	RECONCILIATION = "RECONCILIATION",
}

export const ORIGIN_TAB_MAP: Record<InventoryTab, InventoryTab[]> = {
	[InventoryTab.NEW_VEHICLES]: [InventoryTab.NEW_VEHICLES, InventoryTab.PREOWNED_VEHICLES],
	[InventoryTab.PREOWNED_VEHICLES]: [InventoryTab.NEW_VEHICLES, InventoryTab.PREOWNED_VEHICLES],
	[InventoryTab.KMS]: [InventoryTab.KMS],
	[InventoryTab.DEALER_TRADES]: [InventoryTab.DEALER_TRADES],
	[InventoryTab.RECONCILIATION]: [InventoryTab.RECONCILIATION],
};
